import axios from "axios";
import { RECEIVED_INVITATIONS_URL } from "../../utils";

export const fetchReceivedInvitations = () => {
  return axios.get(RECEIVED_INVITATIONS_URL);
};
